import DirectButtonLink from '../button/DirectButtonLink';
import RouteHelper from '../../helpers/RouteHelper';

import styles from './styles.scss';

const Promo = ({ big, suggestedShopId }) => {
	const shopUrl = RouteHelper.getExternalUrlByShopId(suggestedShopId);

	return (
		<div className={`${styles.wrapper} ${big ? styles.big : ''}`}>
			<div className={styles.inner}>
				<div className={styles.content}>
					<div className={styles.headline}>Get 10&times; higher chance to win</div>
					<div>Become VIP member of Footshop Club</div>
					<div className={styles.buttonWrapper}>
						<DirectButtonLink
							href={`${shopUrl}profile/login#register`}
							text={'Sign up'}
							showArrow
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Promo;



// WEBPACK FOOTER //
// ./components/promo/Promo.js